export default "__VITE_ASSET__WFkAh$Td__"